<script lang="ts">
  import type { Header } from '../types';
  export let data: Header;
  export let id: string | undefined = undefined;
</script>

<p
  class="mb-5 scroll-mt-12 text-2xl font-medium md:text-3xl [&>a]:font-medium [&>a]:underline [&>a]:decoration-black/50 dark:[&>a]:decoration-white/50"
  {id}
>
  <!-- eslint-disable-next-line -->
  {@html data.text}
</p>
